module.exports = __webpack_public_path__ + "static/media/edit-img.fa754ed3.svg";